<template>
  <div class="py4 px3">
    <WebshopHeader class="hide">
    </WebshopHeader>
    <h1>Vilkår og betingelser</h1>
    <div class="mb4">
    </div>
    <div class="clearfix" v-if="loading">
      <div class="col-12">
        <div class="loader"></div>
      </div>
    </div>
  	<div class="mb2" v-else>
      <p class="terms-data" v-html="termsAndConditionData"></p>
  	</div>
  </div>
</template>

<script>
import WebshopHeader from './header'
export default {
  name: '',
  components: {
    WebshopHeader
  },
  data () {
    return {
      loading: true,
      termsAndConditionData: []
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.displayTermsandConditions()
  },
  methods: {
    displayTermsandConditions () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'bitrix/getWebshopTermsAndConditions'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.termsAndConditionData = res.data[0].PROPERTY_TERMS_AND_CONDITIONS_VALUE.TEXT
            this.setLinkProperties()
            this.loading = false
          } else {
            console.log('Error in displayTermsandConditions()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    setLinkProperties () {
      setTimeout(() => {
        var link = document.querySelectorAll('.terms-data p a')
        for (var i = 0; i < link.length; i++) {
          link[i].setAttribute('target', '_blank')
          link[i].classList.add('no-hover')
        }
      }, 500)
    }
  }
}
</script>
<style>
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// TermsAndConditions.vue?5e7993ac